import { ConfigureDebugPanelOptions } from './lib/configureDebugPanel';
import { isProduction } from './lib/environment';
import { DebugPanelReplicant } from './lib/extendReplicantConfigForDebugPanel';

function withModule(onModule: (module: typeof import('./lib/configureDebugPanel')) => void) {
    // Lazy load to keep production build sizes down
    if (!isProduction()) {
        void import('./lib/configureDebugPanel').then(onModule);
    }
}

/** Configure the debug panel. */
export function configureDebugPanel<T extends DebugPanelReplicant>(opts: ConfigureDebugPanelOptions<T>) {
    withModule((module) => {
        module.configureDebugPanel(opts);
    });
}

/** Sets whether the debug panel is expanded or collapsed. */
export function setDebugPanelExpanded(expanded: boolean) {
    withModule((module) => {
        module.setExpanded(expanded);
    });
}

/** Sets whether the debug panel is visible or invisible. */
export function setDebugPanelVisible(visible: boolean) {
    withModule((module) => {
        module.setVisible(visible);
    });
}

export type {
    NumberSchema,
    StringSchema,
    BooleanSchema,
    ButtonSchema,
    ValueSchema,
    UISchema,
    ConfigureDebugPanelOptions,
} from './lib/configureDebugPanel';
